import {normalizeMeasurementPagePath} from './bullstory-measurement/source';

// Public report URLs contain a resource ID, not a visitor identity. Never export that ID.
export function biteMeasurementPath(path:string) {
  if(/^\/bite\/(?:card|share|shared)\/[a-z0-9-]{1,80}\/?$/i.test(path))return '/bite/report';
  return normalizeMeasurementPagePath(path);
}
